<template>
  <div class="cambiar-password-page">
    <div class="bg-grid" aria-hidden="true"></div>

    <div class="cambiar-password-shell">
      <!-- Header -->
      <header class="page-header fade-in">
        <div>
          <h1 class="page-title">Cambiar contraseña</h1>
          <p class="page-sub">Actualiza la contraseña de tu cuenta</p>
        </div>
      </header>

      <!-- Form -->
      <section class="fade-in delay-100">
        <div class="card-flat">
          <div class="card-flat-body">
            <v-form ref="form" v-model="formValido" class="dark-form">
              <div class="field">
                <label class="field-label">Contraseña actual</label>
                <v-text-field
                  v-model="passwordActual"
                  :append-icon="mostrarPasswordActual ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="mostrarPasswordActual ? 'text' : 'password'"
                  outlined
                  dense
                  counter
                  hide-details="auto"
                  placeholder="Tu contraseña actual"
                  class="dark-input"
                  @click:append="mostrarPasswordActual = !mostrarPasswordActual"
                ></v-text-field>
              </div>

              <div class="field">
                <label class="field-label">Contraseña nueva</label>
                <v-text-field
                  v-model="nuevaPassword"
                  :append-icon="mostrarNueva ? 'mdi-eye' : 'mdi-eye-off'"
                  :rules="[rules.required, rules.min]"
                  :type="mostrarNueva ? 'text' : 'password'"
                  outlined
                  dense
                  counter
                  hide-details="auto"
                  placeholder="Mínimo 8 caracteres"
                  class="dark-input"
                  @click:append="mostrarNueva = !mostrarNueva"
                ></v-text-field>
              </div>

              <div class="field">
                <label class="field-label">Repite la nueva contraseña</label>
                <v-text-field
                  v-model="repitePassword"
                  :append-icon="mostrarRepetida ? 'mdi-eye' : 'mdi-eye-off'"
                  :rules="[rules.required, rules.min]"
                  :type="mostrarRepetida ? 'text' : 'password'"
                  outlined
                  dense
                  counter
                  hide-details="auto"
                  placeholder="Repite la contraseña"
                  class="dark-input"
                  @click:append="mostrarRepetida = !mostrarRepetida"
                ></v-text-field>
              </div>
            </v-form>

            <div class="form-actions">
              <button class="btn-primary" :disabled="!formValido" @click="cambiar">
                Registrar
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>

    <v-snackbar v-model="mostrarMensaje" :timeout="3000" :color="mensaje.color" top right>
      {{ mensaje.texto }}
    </v-snackbar>
  </div>
</template>

<script>
import HttpService from "../../Servicios/HttpService";
export default {
  name: "CambiarPassword",

  data: () => ({
    mostrarMensaje: false,
    mensaje: {
      texto: "",
      color: "",
    },
    formValido: false,
    mostrarPasswordActual: false,
    mostrarNueva: false,
    mostrarRepetida: false,
    passwordActual: "",
    nuevaPassword: "",
    repitePassword: "",
    rules: {
      required: (value) => !!value || "Debes colocar este dato.",
      min: (v) => v.length >= 8 || "Mínimo 8 caracteres",
    },
  }),

  methods: {
    async cambiar() {
      let passwordActualCoincide = await this.verificarPasswordActual();
      console.log(passwordActualCoincide);
      if (!passwordActualCoincide) {
        this.mostrarMensaje = true;
        this.mensaje = {
          texto: "La contraseña actual ingresada es incorrecta",
          color: "error",
        };
        return;
      }

      if (this.nuevaPassword !== this.repitePassword) {
        this.mostrarMensaje = true;
        this.mensaje = {
          texto: "La contraseña repetida debe coincidir con la nueva",
          color: "error",
        };
        return;
      }

      let payload = {
        metodo: "cambiar_pass",
        idUsuario: localStorage.getItem("idUsuario"),
        password: this.repitePassword,
      };

      HttpService.registrar(payload, "usuarios.php").then((resultado) => {
        if (resultado) {
          this.mostrarMensaje = true;
          this.mensaje = {
            texto:
              "La contraseña se ha actualizado. Debes iniciar sesión de nuevo",
            color: "success",
          };
          localStorage.removeItem("logeado");
          window.location.reload();
        }
      });
    },

    async verificarPasswordActual() {
      let payload = {
        metodo: "verifica_pass",
        password: this.passwordActual,
        id: localStorage.getItem("idUsuario"),
      };
      let respuesta = await HttpService.obtenerConDatos(
        payload,
        "usuarios.php"
      );
      return respuesta;
    },
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@500;700&family=Inter:wght@400;500;600&family=JetBrains+Mono:wght@500&display=swap');

/* ===== TOKENS ===== */
.cambiar-password-page {
  --bg: #0E0E10;
  --card: #17171A;
  --card-border: #26262A;
  --text-primary: #F2F2ED;
  --text-secondary: #8C8C93;
  --text-tertiary: #5C5C62;
  --accent: #C8FF4D;
  --error: #FF6B6B;
  --radius: 4px;

  --font-display: 'Space Grotesk', sans-serif;
  --font-body: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
}

.cambiar-password-page {
  min-height: 100vh;
  background: var(--bg);
  color: var(--text-primary);
  font-family: var(--font-body);
  position: relative;
  padding: 40px;
}

.bg-grid {
  position: fixed;
  inset: 0;
  background-image:
    linear-gradient(rgba(242, 242, 237, 0.02) 1px, transparent 1px),
    linear-gradient(90deg, rgba(242, 242, 237, 0.02) 1px, transparent 1px);
  background-size: 48px 48px;
  pointer-events: none;
  z-index: 0;
}

.cambiar-password-shell {
  position: relative;
  z-index: 1;
  max-width: 480px;
  margin: 0 auto;
}

/* ===== HEADER ===== */
.page-header {
  margin-bottom: 24px;
}

.page-title {
  font-family: var(--font-display);
  font-size: 22px;
  font-weight: 700;
  margin: 0 0 4px;
}

.page-sub {
  font-size: 13px;
  color: var(--text-secondary);
  margin: 0;
}

/* ===== CARD ===== */
.card-flat {
  background: var(--card);
  border: 1px solid var(--card-border);
  border-radius: var(--radius);
  overflow: hidden;
}

.card-flat-body {
  padding: 24px;
}

.dark-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.field-label {
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.02em;
  color: var(--text-secondary);
  text-transform: uppercase;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 22px;
  padding-top: 20px;
  border-top: 1px solid var(--card-border);
}

.btn-primary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--accent);
  color: var(--bg);
  border: none;
  border-radius: var(--radius);
  padding: 10px 18px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: filter 0.15s ease;
}

.btn-primary:hover:not(:disabled) {
  filter: brightness(1.08);
}

.btn-primary:disabled {
  opacity: 0.45;
  cursor: default;
}

/* ===== Overrides v-text-field (Vuetify) ===== */
.dark-input >>> .v-input__slot {
  background: var(--bg) !important;
  border-radius: 4px !important;
  box-shadow: none !important;
  min-height: 42px !important;
}

.dark-input >>> fieldset {
  border-color: var(--card-border) !important;
  border-width: 1px !important;
  border-radius: 4px !important;
  transition: border-color 0.15s ease;
}

.dark-input >>> .v-input--is-focused fieldset {
  border-color: var(--accent) !important;
  border-width: 1.5px !important;
}

.dark-input >>> input {
  color: var(--text-primary) !important;
  font-family: var(--font-body) !important;
  font-size: 14px !important;
  caret-color: var(--accent) !important;
}

.dark-input >>> input::placeholder {
  color: var(--text-tertiary) !important;
  opacity: 1 !important;
}

.dark-input >>> .v-icon {
  color: var(--text-tertiary) !important;
}

.dark-input >>> .v-counter {
  color: var(--text-tertiary) !important;
  font-size: 11px !important;
}

.dark-input >>> .v-messages {
  color: var(--error) !important;
}

/* ===== MOTION ===== */
.fade-in {
  animation: fadeIn 0.4s ease both;
}

.delay-100 { animation-delay: 0.05s; }

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@media (prefers-reduced-motion: reduce) {
  .fade-in { animation: none; }
}

/* ===== RESPONSIVE ===== */
@media (max-width: 768px) {
  .cambiar-password-page {
    padding: 20px;
  }

  .card-flat-body {
    padding: 18px;
  }

  .form-actions .btn-primary {
    width: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Usuarios/CambiarPassword.vue